import { useReduxState } from 'hooks';
import { Icon } from 'components/common/icons';

const PageServiceDisruptionInfo = () => {
  const { language, serverConfig, theme } = useReduxState();

  const { serviceDisruptionInfo } = serverConfig || {};

  if (!serviceDisruptionInfo?.enabled) return null;

  const category = serviceDisruptionInfo.category || 'warning';

  return (
    <div className={`service-disruption service-disruption-${category}`}>
      <div className="container">
        <div className="inner">
          <div className="icon">
            <Icon
              icon={
                {
                  error: 'times-circle' as const,
                  info: 'exclamation-circle' as const,
                  warning: 'exclamation-triangle' as const
                }[category]
              }
            />
          </div>

          <div className="content">
            <div className="title">
              {language === 'fi-FI'
                ? serviceDisruptionInfo.titleFi
                : serviceDisruptionInfo.title}
            </div>

            <div className="description">
              {language === 'fi-FI'
                ? serviceDisruptionInfo.descriptionFi
                : serviceDisruptionInfo.description}
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        .service-disruption {
          font-size: 1.3rem;
          padding: 10px 0;
        }
        .service-disruption-error {
          background-color: ${theme.dangerLightColor};
          color: ${theme.dangerLightTextColor};
        }
        .service-disruption-info {
          background-color: ${theme.lightGreyLighter};
          color: ${theme.textColorLight};
        }
        .service-disruption-warning {
          background-color: ${theme.warningLightColor};
          color: ${theme.warningLightTextColor};
        }
        .inner {
          display: flex;
          gap: 7px;
        }
        .icon {
          font-size: 1.2rem;
          padding-top: 1px;
        }
        .title {
          display: inline;
          font-weight: 600;
          margin-right: 5px;
        }
        .description {
          display: inline;
          font-weight: 400;
        }
      `}</style>
    </div>
  );
};

export default PageServiceDisruptionInfo;
